import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";

export const STAGES = ["NEW", "ASSESSMENT_STARTED", "ASSESSMENT_COMPLETED", "ENGAGED", "HIGH_INTENT", "CHECKOUT_ABANDONED", "CONVERTED", "INACTIVE", "LOST"];
export const SEGMENTS = ["CURIOUS", "EVALUATOR", "DISAPPOINTED", "ENGAGED", "HIGH_INTENT", "CHECKOUT_ABANDONER", "INACTIVE", "CONVERTED"];
export const MK_SEGMENTS = { prospects: "Prospects", scan_leads: "Scan leads", free_users: "Free users", trial: "Trial", paid: "Paid", all: "Everyone" };
export const SCORE_NOTE = "Scores reflect RPOPRO's own evaluation criteria, not a universal ATS score.";

export const label = (s) => String(s || "").toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()).replace(/\b(Ai|Ats|Cv)\b/g, (w) => w.toUpperCase());
export const usd = (n) => (n == null ? "—" : `${Number(n) < 0 ? "-" : ""}$${Math.abs(Number(n)).toLocaleString(undefined, { minimumFractionDigits: Number(n) % 1 ? 2 : 0, maximumFractionDigits: 2 })}`);
export const pct = (n) => (n == null ? "—" : `${Math.round(Number(n) * (Number(n) <= 1 && Number(n) > 0 ? 100 : 1))}%`);
export const num = (n) => (n == null ? "—" : Number(n).toLocaleString());
export const when = (d) => (d ? new Date(d).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "—");

export const STAGE_CLS = {
  HIGH_INTENT: "border-[#D4AF37]/60 bg-[#33290D] text-[#F3C649]", CONVERTED: "border-emerald-500/40 bg-emerald-500/10 text-emerald-300",
  CHECKOUT_ABANDONED: "border-orange-500/40 bg-orange-500/10 text-orange-300", LOST: "border-red-500/40 bg-red-500/10 text-red-300",
  INACTIVE: "border-zinc-600 bg-zinc-800/60 text-zinc-400", ENGAGED: "border-sky-500/40 bg-sky-500/10 text-sky-300",
};

export const safeCell = (v) => {
  const s = String(v ?? "");
  return /^[=+\-@\t\r]/.test(s) ? `'${s}` : s;
};

export const download = (blob, name) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
};

export const useAdminGet = (path) => {
  const [state, setState] = useState({ data: null, loading: true, missing: false, error: "" });
  const load = useCallback(() => {
    if (!path) return;
    setState((s) => ({ ...s, loading: true }));
    api.get(path).then((r) => setState({ data: r.data, loading: false, missing: false, error: "" }))
      .catch((e) => setState({ data: null, loading: false, missing: e.response?.status === 404, error: e.response?.status === 404 ? "" : errMsg(e) }));
  }, [path]);
  useEffect(() => { load(); }, [load]);
  return { ...state, reload: load, setData: (d) => setState((s) => ({ ...s, data: typeof d === "function" ? d(s.data) : d })) };
};
